// Module positions (col, row) in the 7x7 finder pattern
// Dark 3x3 core: modules (2,2) through (4,4)
export const DARK_CORE_MODULES: ReadonlyArray<[number, number]> = [
  [2, 2],
  [3, 2],
  [4, 2],
  [2, 3],
  [3, 3],
  [4, 3],
  [2, 4],
  [3, 4],
  [4, 4],
];
